module.exports = __webpack_public_path__ + "static/media/case5.c02acaff.jpg";